<div id="notice-frame">
    <h1 mat-dialog-title>Notice</h1>

    <div mat-dialog-content>
        <div class="alert {{ msgClass }}">
            {{ data.message }}
        </div>
    </div>

    <div mat-dialog-actions class="controls">
        <div>
            <button mat-button (click)="onNoClick()">
                <span>Ok</span>
            </button>
        </div>
    </div>
</div>
